import { render, staticRenderFns } from "./FlashCardFilter.vue?vue&type=template&id=9bcf144a&"
import script from "@/scripts/FlashCard/FlashCardDetail/components/FlashCardFilter?vue&type=script&lang=js&"
export * from "@/scripts/FlashCard/FlashCardDetail/components/FlashCardFilter?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports